import { Directive, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appIntTransform]',
  standalone: true,
})
export class IntTransformDirective {
  @Input({ required: false }) parseAs: 'string' | 'number' = 'string';

  constructor(private ngControl: NgControl) {}

  @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {
    const digitsOnly = value.replace(/[^0-9]/g, '');
    const transformedValue = this.parseAs === 'number' ? Number(digitsOnly) : digitsOnly;

    this.ngControl.control?.setValue(transformedValue, { emitEvent: false });
  }
}
